var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8841 12.244L16.6603 11.8231C16.6177 11.8085 16.571 11.8111 16.5302 11.8305C16.4895 11.8499 16.4579 11.8844 16.4423 11.9267C16.4013 12.0368 16.3582 12.1447 16.3128 12.2526C15.9287 13.1613 15.3783 13.9792 14.6747 14.6807C13.9789 15.3786 13.1543 15.935 12.2466 16.3188C11.3063 16.7164 10.2955 16.9205 9.2747 16.9188C8.243 16.9188 7.2437 16.7181 6.30269 16.3188C5.39499 15.935 4.5704 15.3786 3.87461 14.6807C3.17317 13.9792 2.6228 13.1613 2.23647 12.2526C1.84111 11.3118 1.63854 10.3012 1.64078 9.2807C1.64078 8.249 1.8415 7.2475 2.24078 6.30653C2.62496 5.39789 3.17532 4.5799 3.87893 3.87845C4.57472 3.1805 5.39931 2.62417 6.307 2.24031C7.2437 1.84102 8.2451 1.6403 9.2768 1.6403C10.3085 1.6403 11.3078 1.84102 12.2488 2.24031C13.1565 2.62417 13.9811 3.1805 14.6769 3.87845C14.897 4.10075 15.1042 4.33169 15.2941 4.57558L16.5848 3.5655C14.8862 1.39426 12.2423 -0.0021575 9.2725 2.50225e-06C4.10124 0.0021625 -0.0513205 4.20219 0.000479398 9.3756C0.0522793 14.4584 4.18541 18.5613 9.2768 18.5613C13.2804 18.5613 16.6905 16.0231 17.9898 12.4684C18.0222 12.3778 17.9747 12.2764 17.8841 12.244Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5481 8.74367L13.1677 6.13751L18.7141 1.9022L19.5481 8.74367Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate2);
export default __webpack_public_path__ + "static/media/update2.930301d7b08e4062f55fd17a3f85155a.svg";
export { ForwardRef as ReactComponent };